<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="CustomerEdit"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start">
                    {{ $t("customerEditTxt") }}
                  </h6>
                  <button
                    class="btn btn-default float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    ></div>

                    <div class="card">
                      <div class="card-body">
                        <h5 class="General"></h5>
                        <hr>
                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label"
                              >Sales</label
                            >
                          </div>
                          <div class="col-lg-3">
                            <v-select
                              :options="fetchSales"
                              v-model="sales"
                              label="sales_name"
                              return-object
                              @search="asyncSearchSales"
                            ></v-select>
                            <div v-if="errors.sales_name">
                              <div
                                v-for="error in errors.sales_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label"
                              >Business Unit</label
                            >
                          </div>
                          <div class="col-lg-4">
                            <v-select
                              :options="fetchBusinessUnit"
                              v-model="business_unit"
                              label="bu_name"
                              return-object
                              @search="asyncSearchSystemBusinessUnit"
                            ></v-select>

                            <div v-if="errors.bu_id">
                              <div
                                v-for="error in errors.bu_id"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("statusTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <!-- <select
                              class="form-control"
                              name="company_id"
                              id="company_id"
                              v-model="forms.company_id"
                            >
                              <option
                                v-for="(a, index) of fetchCompany"
                                :value="a.company_id"
                                :key="index"
                              >
                                {{ a.code }} | {{ a.name }}
                              </option>
                            </select> -->

                            <v-select
                            
                              :options="statustype"
                              v-model="forms.status"
                              label="code"
                              return-object
                              @search="asyncSearchCompany"
                            ></v-select>

                            

                            <div v-if="errors.company_id">
                              <div
                                v-for="error in errors.company_id"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label"
                              >Area</label
                            >
                          </div>
                          <div class="col-lg-4">
                            <v-select
                              :options="fetchArea"
                              v-model="area"
                              label="area_name"
                              return-object
                              @search="asyncSearchArea"
                            ></v-select>

                            <div v-if="errors.area_id">
                              <div
                                v-for="error in errors.area_id"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                         
                        </div>
                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("customerCodeTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <input
                              type="text"
                              class="form-control"
                              id="customer_code"
                              :placeholder="$t('customerCodeTxt')"
                              v-model="forms.customer_code"
                              required
                            />
                            <div v-if="errors.customer_code">
                              <div
                                v-for="error in errors.customer_code"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("customerNameTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-4">
                            <input
                              type="text"
                              class="form-control"
                              id="customer_name"
                              :placeholder="$t('customerNameTxt')"
                              v-model="forms.customer_name"
                              required
                            />

                            <div v-if="errors.customer_name">
                              <div
                                v-for="error in errors.customer_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                       
                      </div>
                    </div>

                    <br />

                    

                  

                    
                 

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from '@/middleware/mixinAddress.js';


export default {
  name: "CustomerEdit",
  mixins: [myMixinAddress],
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      statustype :["Active","Non Active"],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      permision_role: [],
      fetchBusinessUnit: [],
      fetchArea: [],
      fetchSales: [],
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      sales:[],
      business_unit:[],
      area:[],
      // company: [],
      // region: [],
      // postalCode: [],
      // countryCode: [],
      // provinceCode: [],
      // cityCode: [],
      // districtCode: [],
      // subDistrictCode: [],
      // fetchBusinessUnit: [],
      // fetchPostalCode: [],
      // fetchCountryCode: [],
      // featchProvinceCode: [],
      // featchCityCode: [],
      // featchDistrictCode: [],
      // featchSubDistrictCode: [],
      // featchCompany: [],
      forms: [],
      // postal_code: [],
      // country: [],
      // province: [],
      // city: [],
      // district: [],
      // sub_district: [],
      city_type: "",
      type:"",
    };
  },
  watch: {},
  methods: {
    resetForm() {
    
      this.sales = [];
      this.business_unit = [];
      this.area=[];
      // this.postalCode = [];
      // this.countryCode = [];
      // this.provinceCode = [];
      // this.cityCode = [];
      // this.districtCode = [];
      // this.subDistrictCode = [];
      this.country = [];
      this.province = [];
      this.city = [];
      this.district = [];
      this.sub_district = [];
      this.postal_code = [];
      this.city_type = "";
    },


 
 
    backForm() {
      window.location.href = "/customer";
    },

    loadData(id) {
      const baseURI = this.$settings.endPoint + "customer/detail-edit/" + id;
      return this.$http.get(baseURI).then((response) => {
        this.forms = response.data.datas;
      
        // this.sales_email=this.forms.sales_email;
        // this.sales_name=this.forms.sales_name;
        // this.sales_id = this.forms.sales_id;
      this.sales = this.forms.master_sales;
      this.business_unit = this.forms.business_unit;
      this.area = this.forms.master_area;

       
 
      });
    },

    loadCompany() {
      const baseURI = this.$settings.endPoint + "company?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    loadCompanyNotLinc() {
      const baseURI =
        this.$settings.endPoint + `company/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company?code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    loadSales() {
      const baseURI = this.$settings.endPoint + "sales?status=Active";
      return this.$http.get(baseURI).then((response) => {
        this.fetchSales = response.data.datas.data;
      });
    },

    asyncSearchSales(ev) {
      const baseURI = this.$settings.endPoint + "sales?status=Active&sales_name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchSales = response.data.datas.data;
      });
    },

    loadBusinessUnit() {
      const baseURI = this.$settings.endPoint + "bu?status=Active";
      return this.$http.get(baseURI).then((response) => {
        this.fetchBusinessUnit = response.data.datas.data;
      });
    },

    asyncSearchSystemBusinessUnit(ev) {
      const baseURI = this.$settings.endPoint + "bu?status=Active&bu_name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchBusinessUnit = response.data.datas.data;
      });
    },

    loadArea() {
      const baseURI = this.$settings.endPoint + "area?status=Active";
      return this.$http.get(baseURI).then((response) => {
        this.fetchArea = response.data.datas.data;
      });
    },

    asyncSearchArea(ev) {
      const baseURI = this.$settings.endPoint + "area?status=Active&area_name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchArea = response.data.datas.data;
      });
    },

   

    // asyncSearchRegion(ev) {
    //   const baseURI = this.$settings.endPoint + "region?region_code=" + ev;

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchRegion = response.data.datas.data;
    //   });
    // },

    // loadRegion() {
    //   const baseURI = this.$settings.endPoint + "region?limit=10";

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchRegion = response.data.datas.data;
    //   });
    // },


    
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
  
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "CustomerController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_update) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    submitData() {
      this.fade(true);
      this.forms.sales_id = this.sales.sales_id;
      this.forms.bu_id = this.business_unit.bu_id;
      this.forms.area_id = this.area.area_id;

   
      const baseURI =
        this.$settings.endPoint + "customer/update/" + this.forms.customer_id;
      this.$http
        .put(baseURI, this.forms)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            //this.resetForm();
            this.errors = [];
            this.success(response.data.datas.messages);

            //window.history.back();
            var params = this.$onRandom(this.forms.customer_id);
            window.location.href =
              "/customer/detail/" + params + "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
   this.loadData(params[0]);
    this.fetchIt();
    this.loadSales();
    this.loadBusinessUnit();
    this.loadArea();

  },
};
</script>
<style scoped>
</style>